import api from './client';

export const preferencesApi = {
  /** GET /api/config/admin/settings/public/currency — no auth, returns admin-configured default */
  getSystemDefault: () => api.get('/api/config/admin/settings/public/currency'),
};
